import axios from "axios";
import { addLoanFailure, addLoanStart, addLoanSuccess, deleteLoanFailure, deleteLoanStart, deleteLoanSuccess, fetchLoanFailure, fetchLoanStart, fetchLoanSuccess } from "../slicer/loanSlicer";

const getToken = () =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith("accessToken="))
    ?.split("=")[1];

// Helper function to get the auth headers
const getAuthHeaders = () => {
  const token = getToken();
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};
    
// Fetch Loan details
export const fetchLoanData = () => async (dispatch) => {
  dispatch(fetchLoanStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/getLoanScheme`,
      getAuthHeaders() // Added authentication headers
    );
    // console.log(response.data)
    const messages = response?.data?.data || [];
    dispatch(fetchLoanSuccess(messages));
  } catch (error) {
    console.error("Error fetching loan details:", error);
    dispatch(
      fetchLoanFailure(
        error?.response?.data?.message || "Failed to fetch loan details"
      )
    );
  }
};

export const deleteLoanlist = (id) => async (dispatch) => {
  dispatch(deleteLoanStart()); // Start the deletion process
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/deleteLoanScheme/${id}`,
      getAuthHeaders() // Added authentication headers
    );

    if (response.data.success) {
      dispatch(deleteLoanSuccess(id)); // Dispatch success action with the loan ID
      
    } else {
      throw new Error(response.data.message || "Failed to delete loan");
    }
  } catch (error) {
    console.error("Delete Loan Error:", error);
    dispatch(deleteLoanFailure(error.response?.data?.message || "Failed to delete loan")); // Dispatch failure action
  }
};


export const updateLoanData = (id, payload) => async (dispatch) => {
  try {
    // Dispatch the start action to indicate the update process has started
    dispatch({ type: "updateLoanStart" });

    const token = getToken(); // Get token
    const headers = {}; // Initialize headers object
    // If payload is FormData, axios typically handles 'Content-Type' automatically.
    // We only need to add Authorization.
    if (token) {
      headers["Authorization"] = `Bearer ${token}`; // Add Authorization if token exists
    }

    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/updateLoanScheme/${id}`,
      payload, // FormData is passed here
      { headers } // Passed the combined headers object
    );

    // Dispatch the success action with the updated data
    dispatch({
      type: "updateLoanSuccess",
      payload: response.data,
    });

    // Optionally show a success alert
    alert("Loan updated successfully!"); // Changed alert message from "News updated successfully!"

    // Return the updated data
    return response.data;
  } catch (error) {
    console.error("Error updating loan:", error);

    // Dispatch the failure action with an error message
    dispatch({
      type: "updateLoanFailure",
      payload: error.response?.data?.message || "Something went wrong.",
    });

    // Show an error alert
    alert(`Error updating loan: ${error.message || "Something went wrong."}`);

    // Re-throw the error for further handling
    throw error;
  }
};


// Add loan
export const addLoan = (loanInfo) => async (dispatch) => {
  dispatch(addLoanStart());
  try {
    const token = getToken();
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    // Make API call to add the loan
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/addLoanScheme`,
      loanInfo,
      { headers } // Passed the combined headers object
    );

    // Dispatch success action with the response data
    if (response.data?.success) {
      dispatch(addLoanSuccess(response.data.data));
    } else {
      throw new Error(response.data?.message || "Failed to add loan");
    }
  } catch (error) {
    console.error("Error adding loan:", error); // Log error for debugging

    // Dispatch failure action with an appropriate error message
    dispatch(
      addLoanFailure(
        error.response?.data?.message || "Failed to add loan. Please try again."
      )
    );
  }
};